<template>
	<div class="main login-box">
		<Form ref="formInline" :model="form" :rules="ruleInline">
			<!-- <Tabs :value="tabName" @on-click="onChange">
				<TabPane label="快捷登录注册" name="0"> -->
					<FormItem prop="phone">
						<Input type="text" v-model="form.phone" placeholder="手机号">
							<Icon type="md-phone-portrait" slot="prepend" class="icon" />
						</Input>
					</FormItem>
					<Row>
						<Col span="14">
							<FormItem prop="code">
								<Input 
									type="text" 
									v-model="form.code" 
									placeholder="验证码" 
									class="append"
									:maxlength="6">
									<Icon type="md-lock" slot="prepend" class="icon" />
								</Input>
							</FormItem>
						</Col>
						<Col span="10">
							<VCode ref="VCode" type="1" style="text-align:right" @showSlider="showSliderFunc" :isLogin="true" :agree="agree" :phone="form.phone" />
						</Col>
					</Row>
					<Form-item v-if="showGt&&tabName=='0'">
						<gt @on-success="validate" ref="gt"></gt>
					</Form-item>
					<FormItem style="margin-bottom: 0;">
						<Checkbox v-model="agree">已阅读</Checkbox>
							<a :href="url"   target="_blank">《用户协议》</a>
							<a :href="url1"  target="_blank">《隐私协议》</a>
					</FormItem>
					<FormItem>
						<a @click="exchangeType" >切换员工号登录</a>
					</FormItem>
					<FormItem class="center">
						<Button type="primary" :disabled="!btnDisabled" @click="handleSubmit('formInline')" long>登录</Button>
					</FormItem>
				<!-- </TabPane>
				<TabPane label="密码登录" name="1">
					<FormItem prop="account">
						<Input type="text" v-model="form.account" placeholder="员工号">
							<Icon type="md-person" slot="prepend" class="icon" />
						</Input>
					</FormItem>
					<FormItem prop="password">
						<Input 
							type="password" 
							v-model="form.password"
							placeholder="密码" 
							class="append">
							<Icon type="md-lock" slot="prepend" class="icon" />
						</Input>
					</FormItem>
					<template v-if="eshow">
						<FormItem prop="ephone">
							<Input type="text" v-model="form.ephone" readonly placeholder="手机号">
								<Icon type="md-phone-portrait" slot="prepend" class="icon" />
							</Input>
						</FormItem>
						<Row>
							<Col span="14">
								<FormItem prop="ecode">
									<Input 
										type="text" 
										v-model="form.ecode" 
										placeholder="验证码" 
										class="append"
										:maxlength="6">
										<Icon type="md-lock" slot="prepend" class="icon" />
									</Input>
								</FormItem>
							</Col>
							<Col span="10">
								<VCode ref="EVCode" type="9" style="text-align:right" @showSlider="showESliderFunc" :phone="form.ephone" />
							</Col>
						</Row>
					</template>
					<Form-item v-if="showGt&&tabName=='1'">
						<gt @on-success="validate" ref="gt"></gt>
					</Form-item>
					<FormItem>
						<Checkbox v-model="agree">已阅读</Checkbox>
						<a :href="url"   target="_blank">《用户协议》</a>
						<a :href="url1"  target="_blank">《隐私协议》</a> 
					</FormItem>

					<FormItem class="center" v-if="!eshow">
						<Button type="primary" :disabled="!btnDisabled1" @click="handleSubmit('formInline')" long>登录</Button>
					</FormItem>
					<FormItem class="center" v-else>
						<Button type="primary" :disabled="!btnDisabled2" @click="handleSubmit('formInline')" long>登录</Button>
					</FormItem>
				</TabPane>
			</Tabs> -->
		</Form>
		<Modal v-model="showSlider" title="请完成安全验证" width="400px" :mask-closable="false" >
			<slide-verify
				ref="slideblock"
				:type="eshow && tabName == '1' ? '9' : '1'"
				:l="38"
				:r="8"
				:phone="eshow && tabName == '1' ? form.ephone : form.phone"
				@success="onSuccess"
				@fail="onFail"
				@refresh="onRefresh"
				:slider-text="sliderText"
				:slider-type="sliderType"
			></slide-verify>
			<template slot="footer">
				<div></div>
			</template>
		</Modal>
	</div>
</template>
<script>
import VCode from '@/components/common/VCode'
import gt from '@/components/common/gt'
import SlideVerify from "@/components/common/SlideVerify";
export default {
	components: { VCode, gt, SlideVerify },
	data () {
		return {
			tabName: '0',
			eshow: false,
			showGt: false,
            gt:undefined,
			form: {
				phone: '',
				code: '',
				ephone: '', //员工手机号
				ecode:'' //验证码
			},
			ruleInline: {
				phone: [
					{ required: true, message: '请输入手机号', trigger: 'blur' }
				],
				code: [
					{ required: true, message: '请输入验证码', trigger: 'blur' },
				],
				ecode: [
					{ required: true, message: '请输入验证码', trigger: 'blur' },
				],
				account: [
					{ required: true, message: '请输入员工号', trigger: 'blur' }
				],
				password: [
					{ required: true, message: '请输入密码', trigger: 'blur' }
				]
			},
			bankUrl:this.$route.query.bankUrl,
			agree:false,
			url:window.origin+`/common.html#/aggrementProtocol/1`,
			url1:window.origin+`/common.html#/aggrementProtocol/2`,
      		sliderText: "向右滑动验证",
      		msg: "",
      		validSuccess: false,
			showSlider: false,
			sliderType: 'TEXT'
		}
	},
	computed:{
		btnDisabled () {
			return this.form.phone&&this.form.code&&((this.showGt&&this.gt)||!this.showGt)
		},
		btnDisabled1 () {
			return this.form.account&&this.form.password&&((this.showGt&&this.gt)||!this.showGt)
		},
		btnDisabled2 () {
			return this.form.account&&this.form.password&&this.form.ephone&&this.form.ecode&&((this.showGt&&this.gt)||!this.showGt)
		},
		phone(){
			return this.form.phone?this.form.phone.trim():''
		}
	},
	methods: {
		exchangeType() {
			sessionStorage.setItem('backUrl', this.bankUrl || window.location.origin + '/')
			const iamSdk = window.__USERCENTER__
			const config = JSON.parse(process.env.CONFIG)
			console.log(config)
			iamSdk.configUserCenter({
				ssoUrl: window.location.origin.includes('https://') ? 'https://iama.haier.net' : 'https://iam-test.haier.net', //统一登录页 生产：https://iama.haier.net  测试：iam-test.haier.net, 末尾请不要带“/”
				clientId: config.CLIENT_ID,//应用的cliendtId或K Code,此内容在iam-admin.haier.net或iam-admin-test.haier.net-应用中心-应用管理-应用配置中获取
				tokenUrl: "pc/user/haier/haierAuthCode", //集成了账号中心提供的后端服务的地址，请使用https。具体地址请询问自己的后台开发
				appId: config.APP_ID,  //飞书appid，用于ihaier环境下使用。开放平台创建应用获取（open.feishu.cn）
				redirectUri: sessionStorage.getItem('backUrl') || window.location.origin + '/', //业务系统登录成功后重定向的地址，默认此链接
				exitUrl: window.location.origin + '/common.html#/login', //业务系统退出成功后重定向的地址
				tokenStorageKey: "haier-user-center-access-token", // 本地存储token的key，默认为此值
				userInfoStorageKey: "haier-user-center-user-info", // 本地存储userInfo的key，默认为此值
				extra:{
					debugLog: true
				}
				// clearUrlParamCode: false
			})
			if (!this.agree) {
				this.$Modal.confirm({
					title: '阅读并同意协议',
					content: `我已阅读并同意<a href="${this.url}" target="_blank">《用户协议》</a> <a href="${this.url1}" target="_blank">《隐私协议》</a>`,
					okText: '同意并继续',
					onOk: () => {
						this.agree = true;
						localStorage.setItem('loginType', 'haier')
						iamSdk.login({ invalidateToken: true })
					},
					onCancel: () => {

					}
				});
				return false
			} else {
				localStorage.setItem('loginType', 'haier')
				iamSdk.login({ invalidateToken: true })
			}
		},
		showESliderFunc() {
			if (this.form.ephone == '' || !this.rules.tel.test(this.form.ephone)) {
				this.toast('手机号码格式不正确', 'error');
				return
			}
			this.showSlider = true;
			this.$nextTick(() => {
				if (this.$refs.slideblock) {
					this.$refs.slideblock.reset()
				}
			})
		},
		showSliderFunc(type) {
			if (this.form.phone == '' || !this.rules.tel.test(this.form.phone)) {
				this.toast('手机号码格式不正确', 'error');
				return
			}
			console.log(type,'type')
			this.sliderType = type;
			this.showSlider = true;
			this.$nextTick(() => {
				if (this.$refs.slideblock) {
					this.$refs.slideblock.reset()
				}
			})
		},
		onSuccess() {
			this.validSuccess = true;
			let that = this
			setTimeout(() => {
				that.showSlider = false;
				that.$nextTick(() => {
					if(this.eshow && this.tabName == '1'){
						that.$refs.EVCode.showTime();
					}else{
						if(this.sliderType == 'TEXT'){
							that.$refs.VCode.showTime();
						}
					}
				})
			}, 500)
		},
		onFail() {
			this.validSuccess = false;
		},
		onRefresh() {
			this.msg = "";
		},
		validate (res) {
			this.gt = res;
		},
		onChange (val) {
			this.tabName = val
		},
		handleSubmit(name) {
			if(!this.agree){
				this.$Modal.confirm({
                    title: '阅读并同意协议',
                    content: `我已阅读并同意<a href="${this.url}" target="_blank">《用户协议》</a> <a href="${this.url1}" target="_blank">《隐私协议》</a>`,
					okText:'同意并继续',
                    onOk: () => {
                        this.agree = true;
						setTimeout(()=>{
							this.login('')
						},500)
                    },
                    onCancel: () => {
                       
                    }
                });
				return false
			}
			this.login()
		},
		login(){
			let obj = {}
			if (this.tabName==0) { // 原 手机号验证码登录
				obj = {
					...this.form,
					phone:this.phone,
					challenge:this.gt&&this.gt.geetest_challenge,
					validate:this.gt&&this.gt.geetest_validate,
					seccode:this.gt&&this.gt.geetest_seccode
				}
				this.$axios.post('/user/quickLogin.all',obj).then(res=>{
					if(res.code==10000000){
						this.$store.commit('setUserInfoAll',res.data)
						window.location.href = this.bankUrl;
					}else if(res.code==11000039){
						this.alert(res.msg)
					}else{
						if(res.msg) {
							this.$Notice.error({
								title: '系统提示',
								desc: res.msg
							});
						}
						this.showGt = res.data&&res.data.showValidation;
						if(this.gt&&this.showGt)this.$refs.gt.reset()
					}
					// this.showGt = res.data&&res.data.showValidation;
                    // if(this.gt&&this.showGt)this.$refs.gt.reset()
				})
			}
			if (this.tabName==1) { // 员工号登录
				if (this.eshow) {
					obj = {
						account: this.form.account, 
						phone:this.form.ephone, 
						code:this.form.ecode,
						challenge:this.gt&&this.gt.geetest_challenge,
                        validate:this.gt&&this.gt.geetest_validate,
                        seccode:this.gt&&this.gt.geetest_seccode
					}
					this.$axios.post('/user/bindPhoneAtApp',obj).then(res=>{
						this.$store.commit('setUserInfoAll',res)
						window.location.href = this.bankUrl;
					})
				} else {
					obj = {
						account: this.form.account, 
						password:this.form.password,
						challenge:this.gt&&this.gt.geetest_challenge,
                        validate:this.gt&&this.gt.geetest_validate,
                        seccode:this.gt&&this.gt.geetest_seccode
					}
					this.$axios.post('/user/haier/login.all',obj).then(res=>{
						if (res.code==10000000) {
							this.$store.commit('setUserInfoAll',res.data)
							window.location.href = this.bankUrl;
						} else if (res.code==10000044) {
							this.form.ephone = res.data.phone
							this.eshow = true
							this.showGt = false
						} else {
							if(res.msg) {
								this.$Notice.error({
									title: '系统提示',
									desc: res.msg
								});
							}
							this.showGt = res.data&&res.data.showValidation;
							if(this.gt&&this.showGt)this.$refs.gt.reset()
						}
					})
				}
			}
		},
		readAgree(num){
			window.open()
		}
	}
}
</script>
<style scoped>
	.main{
		width:300px;
		padding-top: 150px;
		background: none;
		margin-top: 100px;
	}
	.icon{
		font-size: 16px;
	}
</style>
<style lang="less">
.login-box{
	.ivu-tabs-nav{
		width: 100%;
		.ivu-tabs-tab{
			margin-right: 0;
			width: 50%;
			text-align: center;
		}
	}
}
</style>


// WEBPACK FOOTER //
// src/pages/common/components/login/index.vue